module.exports = __webpack_public_path__ + "img/no-data1.f8378fd4.png";